// extracted by mini-css-extract-plugin
export var chevronIcon = "_bk-2";
export var teamName = "_bk-1";
export var teamSwitcherButton = "_bk-0";